import { Modal, ModalProps } from "components/Modal";
import { ReactComponent as Ai } from "assets/ai.svg";
import { Button, ButtonVariant } from "../Form/Button";
import { useState } from "react";
import { Agreement } from "./Agreement";
import { CopyImages } from "./CopyImages";
import { DeleteGenderAndEthnicity } from "./DeleteGenderAndEthnicity";
import { DeleteAll } from "./DeleteAll";
import { LinkedAccounts } from "./LinkedAccounts";

interface PrivacyModalProps extends ModalProps {}

enum Screens {
  modal,
  agreement,
  copyImages,
  deleteGenderAndEthnicity,
  deleteAll,
  linkedAccounts,
}

const buttons = [
  [Screens.linkedAccounts, "Handle linked accounts"],
  [Screens.agreement, "Privacy Agreement"],
  [Screens.copyImages, "Request copy of image data"],
  [Screens.deleteGenderAndEthnicity, "Delete gender & ethnicity data"],
  [Screens.deleteAll, "Request a full data deletion "],
] as const;

export function PrivacyModalFull(props: PrivacyModalProps) {
  const [screen, setScreen] = useState<Screens>(Screens.modal);

  return (
    <Modal
      show={props.show}
      onClose={() => {
        if (screen !== Screens.modal) {
          setScreen(Screens.modal);
        } else {
          props.onClose();
        }
      }}
    >
      {screen === Screens.modal && (
        <div className="grid gap-10">
          <div className="grid gap-[29px]">
            <Ai className="justify-self-center" />
            <div className="flex flex-col gap-2">
              {buttons.map((button, idx) => (
                <Button
                  key={idx}
                  onClick={() => setScreen(button[0])}
                  variant={ButtonVariant.FLAT}
                  className="border border-f4f7ff"
                >
                  {button[1]}
                </Button>
              ))}
            </div>
          </div>

          <Button onClick={props.onClose}>Close</Button>
        </div>
      )}
      {screen === Screens.agreement && (
        <Agreement
          buttons={
            <Button onClick={() => setScreen(Screens.modal)}>Done</Button>
          }
        />
      )}
      {screen === Screens.copyImages && (
        <CopyImages onClose={() => setScreen(Screens.modal)} />
      )}
      {screen === Screens.deleteGenderAndEthnicity && (
        <DeleteGenderAndEthnicity onClose={() => setScreen(Screens.modal)} />
      )}
      {screen === Screens.deleteAll && (
        <DeleteAll onClose={() => setScreen(Screens.modal)} />
      )}
      {screen === Screens.linkedAccounts && (
        <LinkedAccounts onClose={() => setScreen(Screens.modal)} />
      )}
    </Modal>
  );
}
